import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";

import { DatePicker } from "antd";
import Loading from "../../loader/loader";
import MultipleSelectRecharge from "./multipleSelectRecharge";
import NkHeader from "../../../common/nkheader";
import NkTable from "../../users/nktable";
import RechargeSectionOne from "./RechargeSectionOne";
import TransactionDetailsPopup from "./TransactionDetailsPopup";
import moment from "moment";

const RaktransactionsPresentational = ({
  transactionData,
  selectedOption1,
  transactionDetail,
  rowOnClick,
  filterValues,
  fromDate = null,
  setFromDate,
  toDate,
  setToDate,
  setModalShow,
  noOfFiltersSelected,
  resetFilter,
  handleFIlter,
  dataLoading,
  buttonRef,
  filterForm,
  onExcelClciked,
  allUserListExcel,
  columns,
  columnsCsv,
  pagination,
  setFilterForm,
  setSizeShow,
  modalShow,
  handleChange,
  handleChange1,
  options,
  options1,
  filtersSelected,
  selectedOption,
  statusFilter,
  typeFilter,
  transactionDetailModel,
  setTransactionDetailModel,
  searchBy,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,
}) => {
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  return (
    <>
      <Container fluid>
        <NkHeader title="Recharge Transactions" />
        <RechargeSectionOne
          searchBy={searchBy}
          setSearchByValue={setSearchByValue}
          setSearchBy={setSearchBy}
          searchByValuePlaceholder={searchByValuePlaceholder}
          searchByValue={searchByValue}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          setModalShow={setModalShow}
          filtersSelected={filtersSelected}
          noOfFiltersSelected={noOfFiltersSelected}
          resetFilter={resetFilter}
          handleFIlter={handleFIlter}
        />
        {filterValues && transactionData.length <= 0 ? (
          <>
            <Card
              className="mb-4"
              style={{
                display: "flex",
                flex: 1,
                textAlign: "center",
                justifyContent: "center",
                padding: "1.25rem 1.5rem",
              }}
            >
              <CardBody>
                <h1 className="mb-0">Sorry ! We cannot find it</h1>
                <h3 className="mb-0">
                  Enter a different search term or remove any filters and try
                  again
                </h3>
              </CardBody>
            </Card>
          </>
        ) : (
          <>
            <Row>
              <div className="col card-parent">
                <Card style={{ padding: "1.25rem 1.5rem" }}>
                  {dataLoading ? (
                    <div style={{ textAlign: "center" }}>
                      <Loading />
                    </div>
                  ) : (
                    <>
                      <NkTable
                        dataexcal
                        filename={"rak-profile"}
                        data={transactionData}
                        buttonRef={buttonRef}
                        type="raktransaction"
                        rowOnClick={rowOnClick}
                        filterdata={filterForm}
                        onExcelClciked={() => onExcelClciked(filterForm)}
                        dataEXCEL={allUserListExcel}
                        columns={columns}
                        columnsCsv={columnsCsv}
                        pagination={pagination}
                        onPagechange={(page) => {
                          setFilterForm({
                            ...filterForm,
                            page: page,
                          });
                        }}
                        showSizeChanged={(pageSize) => {
                          setSizeShow(pageSize);
                          setFilterForm({
                            ...filterForm,
                          });
                        }}
                      />
                    </>
                  )}
                </Card>
              </div>
            </Row>
          </>
        )}
      </Container>
      <MultipleSelectRecharge
        show={modalShow}
        onHide={() => setModalShow(false)}
        statusFilter={statusFilter}
        typeFilter={typeFilter}
        selectedOption={selectedOption}
        selectedOption1={selectedOption1}
        options={options}
        options1={options1}
        handleChange={handleChange}
        handleChange1={handleChange1}
      />
      <TransactionDetailsPopup
        show={transactionDetailModel}
        transactionDetail={transactionDetail}
        onHide={() => setTransactionDetailModel(false)}
      />
    </>
  );
};

export default RaktransactionsPresentational;
